import { z } from 'zod';

export const FULFILLMENT_STATUS_SCHEMA = z.enum(['OPEN', 'CLOSED']);

export type FULFILLMENT_STATUS = z.infer<typeof FULFILLMENT_STATUS_SCHEMA>;

export const CHANNEL_STATUS_SCHEMA = z.enum(['NEW', 'IN_PROGRESS', 'COMPLETED', 'CANCELED']);

export type CHANNEL_STATUS = z.infer<typeof CHANNEL_STATUS_SCHEMA>;
